var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-navbar',{staticClass:"dark-navbar"},[_c('f7-nav-left',[_c('f7-link',{attrs:{"icon-f7":"close","icon-color":"white"},on:{"click":function($event){return _vm.$emit('close')}}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }